import React from "react";

/* eslint-disable react/jsx-props-no-spreading */

const DrupalSettingsContext = React.createContext({});

const defaultSettings = {};

function settingsReducer(state, action) {
  switch (action.type) {
    case "UPDATE": {
      const newState = action.state || {};
      if (JSON.stringify(newState) !== JSON.stringify(state)) {
        return { ...state, ...newState };
      }
      return state;
    }

    default: {
      throw new Error(`Unsupported action type: ${action.type}`);
    }
  }
}

export const useDrupalSettings = () => {
  const context = React.useContext(DrupalSettingsContext);

  if (!context) {
    throw new Error(
      `useDrupalSettings must be used within DrupalSettingsContext`
    );
  }

  const [state, dispatch] = context;
  return { state, dispatch };
};

export const DrupalSettingsContextProvider = props => {
  const [state, dispatch] = React.useReducer(settingsReducer, defaultSettings);
  const value = React.useMemo(() => [state, dispatch], [state]);

  // Sets up interval to watch drupalSettings.
  React.useEffect(() => {
    const interval = setInterval(() => {
      dispatch({
        type: "UPDATE",
        state: window.drupalSettings || {}
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return <DrupalSettingsContext.Provider value={value} {...props} />;
};
